export default function Guarantee() {
  return (
    <section className="guarantee-section">
      <div className="container">
        <div className="guarantee-box">
          <div className="guarantee-icon">&#128170;</div>
          <div className="guarantee-content">
            <h3>Garance spokojenosti</h3>
            <p>Nastavíme vám SyncroX a otestujeme na reálných datech. <strong>Pokud po prvním měsíci nebudete spokojení, vrátíme vám implementační poplatek</strong> — a rozejdeme se v dobrém. Žádné riziko na vaší straně.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
